/*
  CUSTOM: Hide the Klaviyo sign-up pop-up / flyout / teaser while the cart drawer is open (Robb 2026-11-04:
  "the pop-up showing in the cart" covered the checkout button on phones). Restores them when the drawer closes,
  so Klaviyo's own state (and its scroll lock) stays consistent; nothing is permanently hidden.
  Loaded once from layout/theme.liquid (the one allowed hook) next to custom-gorgias-chat-links.js.
  DEPENDS ON: the <cart-drawer> element toggling an open state (Broadcast uses the class "is-open"; also
  listens to the theme:cart-drawer:show event our other snippets dispatch). If neither is present the script does
  nothing and the pop-up behaves as before. No Broadcast JS is called.
  AUTHOR: Claude / Robb   DATE: 2026-11-04   TO REMOVE: delete the script tag in layout/theme.liquid.
*/
(function () {
  'use strict';
  if (window.__opPopupCartGuard) return;
  window.__opPopupCartGuard = true;
  var SEL = '[aria-label="POPUP Form"],[aria-label="FLYOUT Form"],[aria-label="TEASER Form"]';
  var css = document.createElement('style');
  css.setAttribute('data-op-popup-guard', '');
  css.textContent = 'body.op-cart-open ' + SEL.split(',').join(',body.op-cart-open ') + '{display:none !important;visibility:hidden !important}';
  (document.head || document.documentElement).appendChild(css);

  function drawer() { return document.querySelector('cart-drawer'); }
  function isOpen(d) {
    if (!d) return false;
    return d.classList.contains('is-open') || d.hasAttribute('open') || d.getAttribute('aria-hidden') === 'false' && d.classList.length > 0 && d.className.indexOf('open') >= 0;
  }
  function sync() {
    var open = isOpen(drawer());
    document.body.classList.toggle('op-cart-open', open);
  }
  function watch() {
    var d = drawer();
    if (!d || d.__opGuardWatched) return;
    d.__opGuardWatched = true;
    if (window.MutationObserver) new MutationObserver(sync).observe(d, { attributes: true, attributeFilter: ['class', 'open', 'aria-hidden'] });
    sync();
  }
  document.addEventListener('theme:cart-drawer:show', function () { document.body.classList.add('op-cart-open'); setTimeout(sync, 600); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  // the drawer element can be injected late by the theme; keep looking for it briefly
  var tries = 0, t = setInterval(function () { watch(); if (drawer() || ++tries > 40) clearInterval(t); }, 500);
})();
